import React from 'react'
import { PARENT_TABS } from '../../data/parentNotificationData'
import { getParentNotificationIcon } from '../../data/parentNotificationIcons'
import s from './Tabs.module.scss'

export const Tabs = ({ tab, onTabChange }) => (
	<div className={s.tabs} role="tablist" aria-label="Parent communication">
		{PARENT_TABS.map(option => {
			const Icon = getParentNotificationIcon(option.iconKey)
			const isActive = tab === option.id

			return (
				<button
					key={option.id}
					type="button"
					role="tab"
					aria-selected={isActive}
					className={`${s.tabs__button} ${isActive ? s['tabs__button--active'] : ''}`.trim()}
					onClick={() => onTabChange(option.id)}
				>
					<Icon aria-hidden />
					{option.label}
				</button>
			)
		})}
	</div>
)

export default Tabs
